<template>
  <section :class="backgroundClasses">
    <CTABlock
      :button="content.buttons?.length ? content.buttons[0] : null"
      :description="content.description"
      :subtitle="content.subtitle"
      :title="content.title"
    />
  </section>
</template>

<script lang="ts">
import { type PropType, toRef } from 'vue'

import CTABlock from '@/components/blocks/CTABlock.vue'
import { useBackgroundColor } from '@/composables/useBackgroundColor.ts'

export default {
  name: 'CTASection',
  components: { CTABlock },
  props: {
    content: {
      type: Object as PropType<CTASection>,
      required: true,
    },
  },
  setup(props) {
    return {
      backgroundClasses: useBackgroundColor(toRef(props.content, 'background')),
    }
  },
}
</script>
